import axios from "axios"
import {BILLING_URL} from "../globals"
import {createQueryParams} from "../helpers/utils"
import {handleError} from "../helpers/errors"

const URL = {
  TRANSACTION: "/transaction/",

  SAVED_CREDIT_CARD_PAY: "/transaction/pay/saved-credit-card/",
  CREDIT_CARD_PAY: "/transaction/pay/credit-card/",
  POST_PAY_PAY: "/transaction/pay/post-pay/",
  NO_TYPE_PAY: "/transaction/pay/no-type/",
  HOSTED_CHECKOUT_PAY: "/transaction/pay/hosted-checkout/",

  SUBSCRIPTIONS: "/subscriptions/",
  HAS_PENDING_SUBSCRIPTION: "/subscriptions/has-pending-subscription-transaction/",
  SHOPPING_CART: "/shopping-cart/",
  SHOPPING_CART_LIST: "/shopping-cart/list/",

  ADD_UPDATE_PROCESSING: "/shopping-cart/add-update-processing/",
  UPDATE_PROCESSING_CART: "/shopping-cart/update-processing-cart/",
  DELETE_PROCESSING_CART: "/shopping-cart/delete-processing-cart/",

  ADD_UPDATE_POST_PROCESSING: "/shopping-cart/add-update-post-processing/",
  UPDATE_POST_PROCESSING_CART: "/shopping-cart/update-post-processing-cart/",
  DELETE_POST_PROCESSING_CART: "/shopping-cart/delete-post-processing-cart/",

  ADD_UPDATE_SUBSCRIPTION: "/shopping-cart/add-update-subscription/",
  DELETE_SUBSCRIPTION_CART: "/shopping-cart/delete-subscription-cart/",

  PAYER_INFO: "/payer-info/",
  NFE_INFO: "/nfe-info/",

  CREDIT_CARDS: "/credit-cards/",
  GET_INSTALLMENTS_OPTIONS: "/credit-cards/get-installments-options/",

  LIST_POST_PROCESSING_PRICES: "/price-post-processing/list-prices/",
  DESCRIBE_PHYSICAL_PRODUCT: "/prices-product/describe-physical-products/",

  USER_CREDITS: "/credits/get-user-credits/",  

  USER_TOTAL_HECTARE_PACKAGE: "/subscriptions/hec-per-type-package/",
  USER_LIST_HECTARE_PACKAGE: "/subscriptions/list-user-hectare-packages/",  
  SPACE_USED: "/subscriptions/get-used-space/",
  GET_AFTER_PROCESSING_ITEM: "/subscriptions/get-after-processing-item/",
  GET_DATA_PACKAGE_HECTARE: "/subscriptions/get-cart-data-post-processing-hectare/",
  LIST_USER_PACKAGE: "/subscriptions/list-user-total-hectare-packages/",

  CONSUME_HECTARE_PACKAGE: "/subscriptions/consume-hectare-package/",
}

const generateCommonHeader = (authToken) => {
  return {
    Authorization: `Bearer ${authToken}`,
  }
}

const axiosInstance = axios.create({
  baseURL: BILLING_URL,
})
axiosInstance.interceptors.response.use(null, handleError)


export const listSubscription = (authToken) => {
  return axiosInstance.get(URL.SUBSCRIPTIONS,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const getHasPendingSubscription = (authToken) => {
  return axiosInstance.get(URL.HAS_PENDING_SUBSCRIPTION,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const listPayerInfo = (authToken) => {
  return axiosInstance.get(URL.PAYER_INFO,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const createPayerInfo = (authToken, payerInfoData) => {
  return axiosInstance.post(URL.PAYER_INFO,
    payerInfoData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const updatePayerInfo = (authToken, idPayerInfo, payerInfoData) => {
  let requestUrl = `${URL.PAYER_INFO}${idPayerInfo}`
  return axiosInstance.put(requestUrl,
    payerInfoData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const listNfeInfo = (authToken) => {
  return axiosInstance.get(URL.NFE_INFO,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const createNfeInfo = (authToken, nfeInfoData) => {
  return axiosInstance.post(URL.NFE_INFO,
    nfeInfoData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const updateNfeInfo = (authToken, idNfeInfo, nfeInfoData) => {
  let requestUrl = `${URL.NFE_INFO}${idNfeInfo}`
  return axiosInstance.put(requestUrl,
    nfeInfoData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const listPostProcessingPrices = (authToken, abCameraType, abProcessingType) => {
  let requestUrl = `${URL.LIST_POST_PROCESSING_PRICES}?ab_camera_type=${abCameraType}&ab_processing_type=${abProcessingType}`
  return axiosInstance.get(requestUrl,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const listCreditCards = (authToken) => {
  return axiosInstance.get(URL.CREDIT_CARDS,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const getInstallmentsOptions = (authToken, installmentsData) => {
  const queryParams = createQueryParams(installmentsData)
  let requestUrl = `${URL.GET_INSTALLMENTS_OPTIONS}?${queryParams}`
  return axiosInstance.get(requestUrl,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const describePhysicalProduct = (authToken, abPhysicalProduct) => {
  let requestUrl = `${URL.DESCRIBE_PHYSICAL_PRODUCT}?ab_physical_product=${abPhysicalProduct}`
  return axiosInstance.get(requestUrl,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


// ShoppingCart
export const getActiveShoppingCart = (authToken) => {
  return axiosInstance.get(
    URL.SHOPPING_CART,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const checkNpsEvaluation = (authToken) => {
  return axiosInstance.get(
    `${URL.SUBSCRIPTIONS}exist-nps-user/`,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const createNps = (authToken, npsData) => {
  return axiosInstance.post(`${URL.SUBSCRIPTIONS}create-nps/`,
    npsData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const addUpdateProcessing = (authToken, cartData) => {
  let requestUrl = `${URL.ADD_UPDATE_PROCESSING}`
  return axiosInstance.put(
    requestUrl,
    cartData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const updateProcessingCart = (authToken, cdShoppingCartProcessing, cartData) => {
  let requestUrl = `${URL.UPDATE_PROCESSING_CART}${cdShoppingCartProcessing}`
  return axiosInstance.put(
    requestUrl,
    cartData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const deleteProcessingCart = (authToken, cdShoppingCartProcessing) => {
  let requestUrl = `${URL.DELETE_PROCESSING_CART}${cdShoppingCartProcessing}`
  return axiosInstance.delete(
    requestUrl,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const addUpdatePostProcessing = (authToken, cartData) => {
  let requestUrl = `${URL.ADD_UPDATE_POST_PROCESSING}`
  return axiosInstance.put(
    requestUrl,
    cartData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const updatePostProcessingCart = (authToken, cdShoppingCartPostProcessing, cartData) => {
  let requestUrl = `${URL.UPDATE_POST_PROCESSING_CART}${cdShoppingCartPostProcessing}`
  return axiosInstance.put(
    requestUrl,
    cartData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const deletePostProcessingCart = (authToken, cdShoppingCartPostProcessing) => {
  let requestUrl = `${URL.DELETE_POST_PROCESSING_CART}${cdShoppingCartPostProcessing}`
  return axiosInstance.delete(
    requestUrl,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const addUpdateSubscription = (authToken, cartData) => {
  let requestUrl = `${URL.ADD_UPDATE_SUBSCRIPTION}`
  return axiosInstance.put(
    requestUrl,
    cartData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const deleteSubscriptionCart = (authToken, cdShoppingCartSubscription) => {
  let requestUrl = `${URL.DELETE_SUBSCRIPTION_CART}${cdShoppingCartSubscription}`
  return axiosInstance.delete(
    requestUrl,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

//Transactions
export const listTransactions = (authToken) => {
  let requestUrl = `${URL.TRANSACTION}`
  return axiosInstance.get(
    requestUrl,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const createSavedCreditCardTransaction = (authToken, idShoppingCart, paymentData) => {
  let requestUrl = `${URL.SAVED_CREDIT_CARD_PAY}${idShoppingCart}`
  return axiosInstance.post(
    requestUrl,
    paymentData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const createCreditCardTransaction = (authToken, idShoppingCart, paymentData) => {
  let requestUrl = `${URL.CREDIT_CARD_PAY}${idShoppingCart}`
  return axiosInstance.post(
    requestUrl,
    paymentData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const createPostPayTransaction = (authToken, idShoppingCart) => {
  let requestUrl = `${URL.POST_PAY_PAY}${idShoppingCart}`
  return axiosInstance.post(
    requestUrl,
    {},
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const createNoTypeTransaction = (authToken, idShoppingCart) => {
  let requestUrl = `${URL.NO_TYPE_PAY}${idShoppingCart}`
  return axiosInstance.post(
    requestUrl,
    {},
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const createHostedCheckoutTransaction = (authToken, idShoppingCart) => {
  let requestUrl = `${URL.HOSTED_CHECKOUT_PAY}${idShoppingCart}`
  return axiosInstance.post(
    requestUrl,
    {},
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


//User credits
export const getUserCredits = (authToken) => {
  let requestUrl = `${URL.USER_CREDITS}`
  return axiosInstance.get(
    requestUrl,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const getUserTotalHectarePackage = (authToken, data) => {
  let requestUrl = `${URL.USER_TOTAL_HECTARE_PACKAGE}`
  return axiosInstance.post(
    requestUrl,
    data,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const listUserHectarePackage = (authToken) => {
  let requestUrl = `${URL.USER_LIST_HECTARE_PACKAGE}`
  return axiosInstance.get(
    requestUrl,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const listSpaceUsed = (authToken) => {
  let requestUrl = `${URL.SPACE_USED}`
  return axiosInstance.get(
    requestUrl,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const getAfterProcessingItens = (authToken, data) => {
  let requestUrl = `${URL.GET_AFTER_PROCESSING_ITEM}`
  return axiosInstance.post(
    requestUrl,
    data,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const getDataPackageHectareCart = (authToken, data) => {
  let requestUrl = `${URL.GET_DATA_PACKAGE_HECTARE}`
  return axiosInstance.post(
    requestUrl,
    data,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const getListUserPackages = (authToken) => {
  let requestUrl = `${URL.LIST_USER_PACKAGE}`
  return axiosInstance.get(
    requestUrl,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const consumeHectarePackage = (authToken, data) => {
  let requestUrl = `${URL.CONSUME_HECTARE_PACKAGE}`
  return axiosInstance.post(
    requestUrl,
    data,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

//User max allowed imgs
export const getUserMaxImgData = (authToken) => {
  return axiosInstance.get(
    `${URL.SUBSCRIPTIONS}get-user-max-img-data/`,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export class HorusBilling {
  constructor() {
    this.isSetup = false
  }

  setUp(authToken){
    this.authToken = authToken
  }

  async checkBillingSignature() {
    const response = await axiosInstance.get(`${URL.SUBSCRIPTIONS}check-billing-signature/`,
      {
        headers: generateCommonHeader(this.authToken),
        withCredentials: true,
      })

    if (!response.ok) {
      if (response.status != 200) {
        return false
      }
    }

    return true
  }
}
